var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "write-my-name-svg"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1000",
      "height": "180",
      "viewBox": "0 0 1000 180",
      "alt": ""
    }
  }, [_c('path', {
    staticClass: "focusable",
    attrs: {
      "id": "typing-area",
      "tabindex": "0",
      "role": "textbox",
      "aria-labelledby": "name",
      "fill": "#6CC",
      "fill-opacity": ".2",
      "d": "M954.7 69.5V.2H283.1v179.6h671.5V69.5z"
    }
  }), _c('path', {
    attrs: {
      "d": "M970 108.5v-1H30v1h940m0-39v-1H30v1h940"
    }
  }), _c('path', {
    attrs: {
      "id": "name",
      "aria-label": "Name",
      "d": "M91.2 27.9H87l.2 71.4-44-71.4H39v80h3.6l.2-73 45 73h3.4v-80m36.7 41.9c-1.6-.4-3.4-.6-5.5-.6-2.6 0-5 .4-7.2 1.3s-4.2 2.2-5.8 3.8c-1.7 1.7-3 3.8-3.9 6.2-.9 2.5-1.4 5.3-1.4 8.3.4 4.9.9 8.5 1.8 10.6.6 1.7 1.4 3.2 2.3 4.4 1 1.3 2.2 2.4 3.5 3.1 1.5 1 3 1.4 4.5 1.4 1.1 0 2.5-.3 4-.8l1.1-.6c1.6-.8 2.9-1.8 4.1-3 1.2-1.3 2.1-2.8 2.8-4.3l-.1 8.4h4.1l-.2-37.3-4.1-.9M117.2 74c1.8-.7 3.7-1.1 5.7-1.1l1.5.1c1.8.3 3 .7 3.6 1 .3 1.1.5 3.3.5 6.6 0 4.1-.2 7.2-.7 9.2-.3 2-1.1 4.3-2.3 6.8-.6 1.3-1.4 2.5-2.2 3.7-.9 1.2-1.9 2.2-3 3-.8.8-2.1 1.3-3.7 1.3-1.4 0-2.6-.5-3.8-1.6-.9-.6-1.7-1.3-2.4-2.3-.6-1-1.2-2.1-1.6-3.4-.8-2.4-1.2-5.4-1.3-9.2.2-2.3.7-4.5 1.6-6.4.9-1.8 2-3.4 3.4-4.8 1.3-1.2 2.9-2.2 4.7-2.9m141.3 18.8c-.7 0-1.2.2-1.7.8-.5.5-.8 1.1-.8 1.8 0 1.8.8 2.7 2.5 2.7 1.8 0 2.7-.9 2.6-2.7 0-1.8-.9-2.6-2.6-2.6M256 81.9c0 1.8.8 2.7 2.5 2.7 1.8 0 2.7-.9 2.6-2.7 0-1.7-.9-2.5-2.6-2.5-.7 0-1.2.3-1.7.8-.6.4-.8 1-.8 1.7M193.3 78c.7 1.4 1.2 3.2 1.4 5.3.2 1.7.3 3.8.2 6.1v18.5h3.6c.2-4.5.1-12.8-.2-24.9-.1-1.8-.4-3.5-1.2-5.2-.7-1.7-1.6-3.2-2.8-4.5-1.2-1.4-2.6-2.4-4.2-3.2-1.7-.8-3.5-1.2-5.4-1.2-1.7 0-3.3.2-4.9.8-1.3.4-2.5 1-3.6 1.8-1.7 1.2-3 2.6-4.1 4.3-1.1-2-2.6-3.6-4.5-4.7-1.1-.6-2.2-1.1-3.5-1.5-1.4-.4-2.8-.6-4.4-.6-1.3-.1-2.6.1-3.9.4-1.2.3-2.3.8-3.4 1.4-2 1.1-3.5 2.4-4.7 3.9v-5.6h-4l.1 38.7h3.7v-14c0-3 .1-5.7.4-8.1.4-2.7 1-4.9 1.9-6.8 1-2 2.2-3.6 3.8-4.7 1.7-1.1 3.7-1.7 6.1-1.7 2.4 0 4.4.5 5.9 1.6 1.4.9 2.4 2.3 3.1 4.2.6 1.6 1.1 3.5 1.3 5.9l.2 23.5h3.8l.2-23.9c.3-2.3.7-4.2 1.4-5.8.7-1.8 1.8-3.1 3.2-4 1.5-1 3.5-1.5 5.8-1.4 2.2 0 4 .5 5.5 1.5 1.4 1 2.4 2.2 3.2 3.9m32.6-8.9c-2.4 0-4.7.5-7 1.5-2.2 1-4.1 2.3-5.8 4.1-1.7 1.7-3 3.7-4 5.9-1 2.3-1.6 4.6-1.6 7 0 2.2.3 4.5.9 6.8.7 2.5 1.8 4.7 3.2 6.6 1.5 2.1 3.4 3.8 5.6 5 1.2.6 2.4 1.1 3.9 1.5 1.4.4 2.9.6 4.5.6 2 0 4.4-.6 7.2-1.9 2.6-1.1 4.7-2.4 6.4-3.7l-1.8-3c-4.3 3.2-8.2 4.9-11.8 5.1-2.1.1-4-.2-5.8-1.1-1.7-.7-3.2-1.8-4.4-3.2-1.2-1.4-2.2-3-3-4.9-.7-1.8-1.1-3.8-1.3-5.9h27.7c1.2 0 1.9-.3 2.4-1 .3-.5.4-1.3.4-2.4.1-1.6-.2-3.3-.8-5.2-.7-2-1.7-3.8-2.9-5.4-1.4-1.8-3.1-3.3-5-4.3-2.1-1.5-4.5-2.1-7-2.1m.5 3.4c1.7 0 3.3.4 4.9 1.2 1.4.7 2.7 1.7 3.8 3 1.1 1.2 1.9 2.5 2.5 3.9.6 1.4.9 2.8.9 4.2 0 .8-.2 1.2-.7 1.4l-26.6-.1c.1-.6.1-.9.2-1.1.2-1.3.7-2.7 1.3-4.1.7-1.5 1.7-2.9 2.8-4.1 1.3-1.4 2.9-2.4 4.6-3.2 1.8-.7 4-1.1 6.3-1.1z"
    }
  }), _c('text', {
    attrs: {
      "id": "text-area",
      "transform": "translate(313.7 107.1)",
      "font-family": "'hwtprint'",
      "font-size": "80",
      "role": "textbox",
      "value": _vm._f("capitalize")(_vm.writtenName),
      "aria-label": _vm._f("capitalize")(_vm.writtenName)
    }
  }, [_vm._v("\n      " + _vm._s(_vm._f("capitalize")(_vm.writtenName)) + "\n    ")])]), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showDone,
      expression: "showDone"
    }],
    staticClass: "btn-common write-button button-done enabled",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.onDoneClick
    }
  }, [_vm._v("\n    DONE\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }